module.exports = __webpack_public_path__ + "static/r1-6922d0e4f2408943e5cdec48c6b0df6c.svg";